import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  display: inline-block;\n  align-items: center;\n  line-height: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  background: ", ";\n  color: ", ";\n  cursor: pointer;\n  text-transform: uppercase;\n\n  ", "\n\n  ", "\n\n  /* Link button styling */\n  ", "\n\n  /* Icon Link button styling */\n  ", "\n\n  /* Icon button styling */\n  ", "\n\n  svg:first-child {\n    margin-right: .5em;\n    margin-left: .5em;\n  }\n\n  svg:last-child {\n    margin-left: .5em;\n    margin-right: .5em;\n  }\n\n  svg:only-child {\n    margin: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButton = styled.button(_templateObject(), function (props) {
  return "".concat(props.theme.button[props.size].lineHeight, "rem");
}, function (props) {
  return "".concat(props.theme.button[props.size].fontSize, "rem");
}, function (props) {
  return props.theme.button.bg;
}, function (props) {
  return props.theme.button.color;
}, function (props) {
  return props.theme.utils.getBoxModel(props.theme.button[props.size].padding, props.theme.button[props.size].border, props.theme.button[props.size].margin);
}, function (props) {
  return props.appearance === 'link' && "\n      padding-left: 0;\n      padding-right: 0;\n      background: none;\n      color: ".concat(props.theme.button.bg, ";\n    ");
}, function (props) {
  return props.as === 'a' && "\n      // display: inline-block;\n      text-decoration: none;\n\n      &:hover {\n        color: white;\n      }\n    ";
}, function (props) {
  return props.as === 'a' && props.icon !== null && "\n      // display: inline-block;\n    ";
}, function (props) {
  return props.icon !== null && "\n    ".concat(props.theme.utils.getBoxModel(props.theme.button.getSize(props.theme.button[props.size].padding, props.icon), props.theme.button[props.size].border, props.theme.button[props.size].margin), ";\n  ");
});
var StyledButtonInner = styled.span(_templateObject2());

function Button(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(StyledButton, props, /*#__PURE__*/React.createElement(StyledButtonInner, null, children));
}

Button.defaultProps = {
  size: 'md',
  icon: null
};
Button.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  appearance: PropTypes.oneOf(['link', 'button']),
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])])
};
export default Button;